module.exports = __webpack_public_path__ + "media/49.a5268003.wav";